import React from 'react';
import HeroSection from '@/components/sections/HeroSection';
import HighlightsSection from '@/components/sections/HighlightsSection';
import LogoStrip from '@/components/sections/LogoStrip';
import ProblemSection from '@/components/sections/ProblemSection';
import MarketSection from '@/components/sections/MarketSection';
import PipelineSection from '@/components/sections/PipelineSection';
import CpmVsCpsSection from '@/components/sections/CpmVsCpsSection';
import TechPillarsSection from '@/components/sections/TechPillarsSection';
import ResultsSection from '@/components/sections/ResultsSection';
import OnboardingSection from '@/components/sections/OnboardingSection';
import CalculatorSection from '@/components/sections/CalculatorSection';
import FinalCtaSection from '@/components/sections/FinalCtaSection';

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <HighlightsSection />
      <LogoStrip />
      <ProblemSection />
      <MarketSection />
      <PipelineSection />
      <CpmVsCpsSection />
      <TechPillarsSection />
      <ResultsSection />
      <OnboardingSection />
      <CalculatorSection />
      <FinalCtaSection />
    </div>
  );
}
